import { useQuery } from 'react-query';
import { QUERY_KEYS, PING_INTERVALS } from '@constants';
import { getCurrentTerm } from '@utils/currentSlide';
import { fetchRebuttalSlides, fetchAllSlides, fetchSlide } from '@services/slides';

/* Custom hook wrappers around react query queries */

const { rebuttalsQuery, currentSlideQuery, allSlidesQuery } = QUERY_KEYS;
const { fiveSeconds } = PING_INTERVALS;

export const useAllSlidesQuery = () => useQuery(allSlidesQuery, fetchAllSlides);

export const useCurrentSlideQuery = (slideId, leadId, firmName, currentTermData) => useQuery([currentSlideQuery, slideId, leadId, firmName], 
    () => fetchSlide(slideId, leadId, firmName),
    {
        onSuccess: data => getCurrentTerm(data, currentTermData),
        refetchInterval: fiveSeconds,
        refetchIntervalInBackground: true
    }
);

export const useRebuttalsQuery = () => useQuery(rebuttalsQuery, fetchRebuttalSlides);
 